module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1296.a8a01416.png";